import { Component, inject } from '@angular/core';
import { SchedulersOverviewConfigService } from '../../services/schedulers-overview-config/schedulers-overview-config.service';

@Component({
    selector: 'lib-schedulers-overview',
    templateUrl: './schedulers-overview.component.html',
    styleUrl: './schedulers-overview.component.scss',
    standalone: false
})
export class SchedulersOverviewComponent {
  public schedulersOverviewConfigService = inject(SchedulersOverviewConfigService);
}
